import React from 'react';
import {Box, Grid} from '@tenancy.nz/ui';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import * as constants from '../../utils/constants';
import Logo from '../Logo';
import {StyledHeader} from './Styles';

function Header({children, logoAlt, logoSrc, logoTo = '/', ...rest}) {
  return (
    <StyledHeader {...rest}>
      <Grid container alignItems="center">
        <Grid item xs={3} lg={2}>
          <Link to={logoTo}>
            <Logo src={logoSrc} alt={logoAlt} />
          </Link>
        </Grid>
        <Grid item xs={9} lg={10}>
          <Box display="flex" justify="flex-end" gap="12px" align="center">
            {children}
          </Box>
        </Grid>
      </Grid>
    </StyledHeader>
  );
}

Header.propTypes = {
  /**
   * Text, component or node
   */
  children: PropTypes.node,

  /**
   * Image alt text to display if logo image is broken
   */
  logoAlt: PropTypes.string,

  /**
   * Path the logo image
   */
  logoSrc: PropTypes.string,

  /**
   * Path the logo image for mobile devices
   */
  logoTo: PropTypes.string,
};

Header.defaultProps = {
  children: '',
  logoAlt: constants.DEFAULT_LOGO_ALT,
  logoSrc: constants.DEFAULT_LOGO,
  logoTo: '/',
};

export default Header;
